var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "visitorDemo" } }, [
    _c("div", { staticClass: "demo-container" }, [
      _c(
        "div",
        {
          staticClass: "demo-header",
          style: {
            background:
              "linear-gradient(0deg," +
              _vm.headerColorFirst +
              "," +
              _vm.headerColorSecond +
              ")",
            color: "white",
          },
        },
        [
          _c("div", { staticClass: "left" }, [
            _c(
              "div",
              { staticClass: "button" },
              [
                _c("md-icon", { style: { color: "white" } }, [
                  _vm._v("chevron_left"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                {
                  staticClass: "title",
                  style: { color: "" + _vm.headerTextColor },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.demoVisitorSampleName")) +
                      "\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content",
                  style: { color: "" + _vm.headerTextColor },
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.demoVisitorSampleSubtitle")) +
                      "\n                    "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "options" },
            [
              _c("md-icon", { style: { color: "white" } }, [
                _vm._v("more_vert"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "chat-body",
          style: {
            background:
              "linear-gradient(0deg," +
              _vm.backgroundColorFirst +
              "," +
              _vm.backgroundColorSecond +
              ")",
            color: "white",
          },
          attrs: { id: "chatBody" },
        },
        [
          _c("div", { staticClass: "representative-message-container" }, [
            _c(
              "div",
              {
                staticClass: "message-container",
                style: {
                  color: _vm.representativeTextColor,
                  backgroundColor: _vm.representativeBubbleColor,
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.demoVisitorSampleAgentMessage")) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "date" }, [
              _vm._v(_vm._s(_vm.$t("message.demoVisitorSampleTime1055"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-message-container first" }, [
            _c("div", { staticClass: "date" }, [
              _vm._v(_vm._s(_vm.$t("message.demoVisitorSampleTime1057"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "message-container",
                style: {
                  color: _vm.customerTextColor,
                  backgroundColor: _vm.customerBubbleColor,
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("message.demoVisitorSampleUserMessage")) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-message-container image" }, [
            _c("div", { staticClass: "date" }, [
              _vm._v(_vm._s(_vm.$t("message.demoVisitorSampleTime1057"))),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "message-container",
              style: {
                color: _vm.customerTextColor,
                backgroundColor: _vm.representativeBubbleColor,
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "visitor-message-container file" }, [
            _c("div", { staticClass: "date" }, [
              _vm._v(_vm._s(_vm.$t("message.demoVisitorSampleTime1057"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "message-container",
                style: {
                  color: _vm.customerTextColor,
                  backgroundColor: _vm.customerBubbleColor,
                },
              },
              [
                _c("DynamicSvg", { attrs: { name: "PDF" } }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text",
                    style: { color: _vm.customerTextColor },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.demoVisitorSampleFileName")) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "arrow" },
                  [
                    _c("md-icon", { style: { color: _vm.customerTextColor } }, [
                      _vm._v("vertical_align_top"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-editor",
          style: { backgroundColor: _vm.backgroundColorFirst },
        },
        [
          _c("div", { staticClass: "editor-wrapper" }, [
            _c("div", { staticClass: "icon-button" }, [
              _c("div", { staticClass: "left" }, [
                _c(
                  "div",
                  { staticClass: "smile-icon" },
                  [_c("md-icon", [_vm._v(" sentiment_satisfied")])],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text", style: { color: _vm.textColor } },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$t("message.demoVisitorSampleInputPlaceholder")
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "actions" }, [
              _c(
                "div",
                { staticClass: "file-button" },
                [_c("md-icon", [_vm._v("attach_file")])],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "send-button",
                  style: { backgroundColor: _vm.buttonColor },
                },
                [
                  _c(
                    "md-icon",
                    { style: { color: _vm.backgroundColorFirst } },
                    [_vm._v("send")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "triangle" },
          [
            _c("DynamicSvg", {
              attrs: { name: "Triangle", color: _vm.backgroundColorFirst },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "back-button",
            style: { backgroundColor: _vm.headerColorFirst },
          },
          [_c("md-icon", [_vm._v("close")])],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "avatar" }, [
      _c("img", { attrs: { src: "/static/img/visitorAvatar.png" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-wrapper" }, [
      _c("div", { staticClass: "image-container" }, [
        _c("img", { attrs: { src: "/static/img/poweredSupsis.png" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }